'use strict'

// import { CookiePolicy } from './lib/CookiePolicy'
import { Svg } from './lib/Svg'
import { TelGrant } from './lib/TelGrant'
import { Smooth } from './lib/Smooth'
import { Drawer } from './lib/Drawer'
import { ScrollStatus } from './lib/ScrollStatus'
import { ScrollAnimation } from './lib/ScrollAnimation'
import { Accordion } from './lib/Accordion'
import { FlexibleSlider } from './lib/FlexibleSlider'
import { EndlessSlider } from './lib/EndlessSlider'
import { Loading } from './lib/Loading'

// new CookiePolicy('optout')
new Svg()
new TelGrant()
new Smooth()
new Drawer()
new ScrollStatus()
new ScrollAnimation()
new Accordion()
new FlexibleSlider()
new EndlessSlider()
new Loading()
